import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ColorPickerEditor from 'common/components/ColorPicker';
import { getColors } from 'common/entities/color/selectors';
import {
    setFormSecondaryButtonColorDefault,
    setFormSecondaryButtonColorHover,
} from 'common/entities/form/styleConfiguration/actions';
import { getFormSecondaryButtonColors } from 'common/entities/form/styleConfiguration/selectors';
import { getFormId } from '../../../../selectors';
import { COLOR_PICKER_DEFAULT, COLOR_PICKER_HOVER } from '../../../../constants/formStyleLabels';
import { SECONDARY_BUTTON_QA } from '../../../../utils/qaIdConstants';

const SecondaryButtonBackgroundPanel = () => {
    const dispatch = useDispatch();
    const formId = useSelector(getFormId);
    const colorList = useSelector(getColors);
    const { default: defaultColor, hover: hoverColor } = useSelector((state) =>
        getFormSecondaryButtonColors(state, formId),
    );

    return (
        <ColorPickerEditor
            colorList={colorList}
            firstColorLabel={COLOR_PICKER_DEFAULT}
            secondColorLabel={COLOR_PICKER_HOVER}
            firstColor={defaultColor}
            secondColor={hoverColor}
            changeFirstColor={(id) => dispatch(setFormSecondaryButtonColorDefault(formId, id))}
            changeSecondColor={(id) => dispatch(setFormSecondaryButtonColorHover(formId, id))}
            qaId={SECONDARY_BUTTON_QA}
        />
    );
};

export default SecondaryButtonBackgroundPanel;
